/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Sendfailed1Inputs */

const zh_password_sendfailed1 = /** @type {(inputs: Password_Sendfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送失败`)
};

const en_password_sendfailed1 = /** @type {(inputs: Password_Sendfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send`)
};

const es_password_sendfailed1 = /** @type {(inputs: Password_Sendfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar`)
};

/**
* | output |
* | --- |
* | "Failed to send" |
*
* @param {Password_Sendfailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_sendfailed1 = /** @type {((inputs?: Password_Sendfailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Sendfailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_sendfailed1(inputs)
	if (locale === "en") return en_password_sendfailed1(inputs)
	return es_password_sendfailed1(inputs)
});
export { password_sendfailed1 as "password_sendFailed" }